/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Rss",
  size: 20
}

const SvgRss = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <circle cx={3.12} cy={16.8} r={1.85} />
    <path
      fill="none"
      strokeWidth={1.1}
      d="M1.5 8.2c.28-.02.56-.04.85-.04 5.22 0 9.46 4.21 9.46 9.41 0 .32-.02.62-.05.93"
    />
    <path
      fill="none"
      strokeWidth={1.1}
      d="M1.5 2.52c.28-.01.56-.02.85-.02 8.37 0 15.15 6.74 15.15 15.07 0 .32-.01.62-.03.93"
    />
  </Svg>
)

SvgRss.defaultProps = defaultProps
export default SvgRss
